export enum ChargerOPEEnum{
    GetAllChargers = 'getAllChargers',
    GetChargers = 'getChargers',
    PutCharger = 'putCharger',
    DelCharger = 'delCharger'
}
